import { baseQuery } from '../baseQuery';

export const getCancelationReasons = async () => {
  const { data } = await baseQuery('cancellation-reasons');

  return data;
};
